<template>
  <CompanyWrapper :isOpenEvent="isOpenEvent">
    <Loading v-if="isLoading"></Loading>
    <BadRequest :lang="lang" v-if="isBadRequest"></BadRequest>
    <InternalServerError
      v-if="isCreateServerError"
      :lang="lang"
    ></InternalServerError>
    <main
      class="main"
      v-if="!isLoading && !isBadRequest && !isCreateServerError"
    >
      <!-- パンくずリスト -->
      <ol class="breadcrumb-trail__list" v-if="!isOpenEvent">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/company/summary` }"
            class="breadcrumb-trail__list--item__link"
          >
            EventList
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/company/event/${this.$route.query.event}` }"
            class="breadcrumb-trail__list--item__link"
          >
            Detail
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{
              path: `/company/ranking`,
              query: {
                event: this.$route.query.event,
                page: this.$route.query.page,
              },
            }"
            class="breadcrumb-trail__list--item__link"
          >
            Result
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{
              path: `/company/ranking/certificate`,
              query: {
                event: this.$route.query.event,
                team: this.$route.query.team,
              },
            }"
            class="breadcrumb-trail__list--item__link"
          >
            Certificate
          </router-link>
        </li>
      </ol>
      <!--表示用-->
      <CertificateWidth1000
        :dataRunner="dataRunner"
        :is-company="true"
      ></CertificateWidth1000>
      <div class="download-button">
        <div class="ie-description" v-if="isInternetExplorer"
          >Internet
          Explorerではダウンロードできないため、別ブラウザでご利用ください。</div
        >
        <PrimaryButton type="button" @click.native="imageDownload">
          {{ Certificate.download[lang] }}
        </PrimaryButton>
      </div>
    </main>
    <!-- 保存用（画面には表示しない(位置 : -9999px)）width: 4093px; height: 2894px; -->
    <CertificateWidth4000
      :dataRunner="dataRunner"
      :is-company="true"
      id="js-download"
      v-if="!isLoading && !isBadRequest && !isCreateServerError"
    >
    </CertificateWidth4000>
  </CompanyWrapper>
</template>

<script>
import CompanyWrapper from "../../../../components/pc/company/CompanyWrapper";
import Loading from "../../../../components/pc/Loading";
import BadRequest from "../../../../components/common/status/BadRequest";
import InternalServerError from "../../../../components/common/status/InternalServerError";
import PrimaryButton from "../../../../components/pc/oauth/PrimaryButton";
import CertificateWidth1000 from "../../../../components/common/CertificateWidth1000";
import CertificateWidth4000 from "../../../../components/common/CertificateWidth4000";
import certificate from "../../../../assets/constants/ranking/certificate/certificate.json";
import { RepositoryFactory } from "../../../../api/RepositoryFactory";
import html2canvas from "html2canvas";
import Download from "downloadjs";
import cognito from "../../../../plugins/cognito";
export default {
  data() {
    return {
      isLoading: true,
      isBadRequest: false,
      isCreateServerError: false,
      isOpenEvent: false,
      dataRunner: null,
      isInternetExplorer: false,
    };
  },
  async created() {
    // IEの時用の文言
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.includes("msie") || userAgent.includes("trident")) {
      this.isInternetExplorer = true;
    }
    const EventRepository = RepositoryFactory.get("event");
    const nassId = this.$route.query.event;
    const params = {
      code: nassId,
      lang: this.lang,
      is_company_event: true,
      company_user_name: cognito.getUserName() || "",
    };
    const response = await EventRepository.getEvent(params);
    this.isOpenEvent = response.data.text.open_event_flag;
  },
  async mounted() {
    // ランナー情報取得
    const isCompany = this.$route.path.includes("company");
    const RankingRepository = RepositoryFactory.get("ranking");
    try {
      let response;
      if (this.$route.query.runner) {
        response = await RankingRepository.getRunner({
          event: this.$route.query.event,
          runner: this.$route.query.runner,
          lang: this.lang,
          is_company_event: isCompany || "",
          company_user_name: cognito.getUserName() || "",
        });
      } else {
        response = await RankingRepository.getTeamRunner({
          event: this.$route.query.event,
          company: this.$route.query.team,
          lang: this.lang,
          is_company_event: isCompany || "",
          company_user_name: cognito.getUserName() || "",
        });
      }
      this.dataRunner = response.data;
    } catch (e) {
      if (e.response.status === 400) {
        this.isBadRequest = true;
        return;
      }
      this.isCreateServerError = true;
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    imageDownload: function () {
      // 非表示の場合変換できないので一瞬表示する
      document.getElementById("js-download").classList.remove("none");
      // 既存のcanvasタグがある場合は削除
      if (document.querySelector("#canvas-tag")) {
        document.querySelector("#canvas-tag").remove();
      }
      // 変換処理
      // PCだと画像が欠けることがあるので scrollX,scrollYを指定する
      html2canvas(document.getElementById("js-download"), {
        scrollX: 0,
        scrollY: -window.scrollY,
      })
        .then(function (canvas) {
          document.getElementById("js-download").classList.add("none");
          const tag = document.getElementById("app").appendChild(canvas);
          tag.id = "canvas-tag";
          tag.classList.add("none");
          Download(tag.toDataURL(), "certificate.png");
        })
        .catch(function (e) {
          console.error(e);
        });
    },
  },
  computed: {
    Certificate: function () {
      return certificate;
    },
    lang: function () {
      return this.$store.state.lang;
    },
  },
  components: {
    Loading,
    BadRequest,
    InternalServerError,
    PrimaryButton,
    CertificateWidth1000,
    CertificateWidth4000,
    CompanyWrapper,
  },
  name: "Certificate",
};
</script>

<style scoped>
.main {
  .download-button {
    margin: 40px 0 0 0;
    text-align: center;
    .ie-description {
      margin: 0 0 16px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pc/company/certificate/Certificate.vue